/**
 * Created by Ning Jiang on 11/24/2016.
 */

import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {IWinRatioConfig, WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";

export class StarStruckSoundConfig implements ISoundConfig {

    public static instance:StarStruckSoundConfig = new StarStruckSoundConfig();

    MAIN_GAME_AMBIANCE:string = "background-music-main";
    BONUS_GAME_AMBIANCE:string = "background-music-bonus";
    REELS_SPINNING_START_ON_SPIN_START:string = "wheels-spinning";
    REELS_DEFAULT_BOUNCE:string[] = ["reel-one-landing", "reel-one-landing", "reel-one-landing"];

    WIN_BIG:string = "bigwin";
    WIN_BIG_END:string[] = ["bigwinEnds1", "bigwinEnds2", "bigwinEnds3"];

    AS_WIN:string = "asWin";
    AS_WIN_BIG:string = "asWinBig";
    WIN_TINY:string = "winTiny";
    WIN_SMALL:string = "winSmall";
    WIN_MEDIUM:string = "winMedium";
    WIN_LARGE:string = "winLarge";
    SYMBOL_WIN_HIT:string = "winHit";
    ANTICIPATION:string = "anticipation";
    ANTICIPATION_BONUS:string = "anticipation2";
    BONUS_WIN:string = "bonusWin";
    BONUS_FAIL:string = "bonusFail";
    BONUS_STAR_OUT1:string = "bonusStarsOut1";
    BONUS_STAR_OUT2:string = "bonusStarsOut2";
    BONUS_STAR_POP:string = "bonusStarPop";
    BONUS_STAR_IN:string = "bonusStarsIn";
    BONUS_STAR_SHUFFLE:string = "bonusStarsMixing";
    BONUS_STAR_PICK:string = "bonusStarPick";
    BONUS_STAR_END:string = "bonusStarToCenter";
    BONUS_STAR_SWEEP:string = "bonusStarSweep";

    constructor() {
        if(StarStruckSoundConfig.instance) {
            throw new Error("StarStruckSoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }

    static getNormalWinSoundName(winRatioConfig:IWinRatioConfig):any {
        if(!winRatioConfig) {
            return null;
        }
        switch(winRatioConfig.type) {
            case WinRatioType.TINY:
                return this.instance.WIN_TINY;
            case WinRatioType.SMALL:
                return this.instance.WIN_SMALL;
            case WinRatioType.MEDIUM:
                return this.instance.WIN_MEDIUM;
            case WinRatioType.LARGE:
                return this.instance.WIN_LARGE;
            default:
                return null;
        }
    }
}